import PropTypes from "prop-types";
import React from "react";
import DataTable from "react-data-table-component";

const paginationComponentOptions = {
  rowsPerPageText: "Filas por página",
  rangeSeparatorText: "de",
  selectAllRowsItem: true,
  selectAllRowsItemText: "Todos",
};

function Table({
  columnsTable,
  filterEnabled,
  className,
  handleFilter,
  filteredData,
  expandedRow,
  handleChange,
  corralonesFilter,
  usersEnabled
}) {
  let rowSelectCritera;
  let corralones = corralonesFilter?.[0]?.corralones;

  rowSelectCritera = (row) =>
    corralones?.some((corralon) => row.id === corralon.id);


  return (
    <div className="datatable--responsive container mt-4">
      {filterEnabled ? (
        <div className="mb-5 form__input--container">
          <input
            className="form__input form__input--search"
            type="text"
            id="filtroDatatable"
            onChange={handleFilter}
          />
        </div>
      ) : (
        ""
      )}

      {usersEnabled ? (      <p className="basePgi__comments d-block">
        <strong>Usuarios</strong> registrados en Tensolite.com
      </p>
      ):(
      <p className="basePgi__comments d-block">
        Los corralones <strong>seleccionados</strong> no se mostrarán en la
        sección Dónde-Comprar
      </p>
      )}

      <DataTable
        selectableRows={!usersEnabled}
        columns={columnsTable}
        data={filteredData?.length > 0 ? filteredData : []}
        customStyles={{
          headCells: {
            style: { backgroundColor: "none" },
          },
        }}
        noDataComponent={"Sin resultados para mostrar"}
        className={`react-dataTable ${className} my-2`}
        expandableRows={expandedRow}
        pagination
        paginationComponentOptions={paginationComponentOptions}
        onSelectedRowsChange={handleChange}
        selectableRowSelected={rowSelectCritera}
      />
    </div>
  );
}

Table.propTypes = {
  filterEnabled: PropTypes.bool,
  className: PropTypes.string,
  columnsTable: PropTypes.arrayOf(PropTypes.shape),
  handleFilter: PropTypes.func,
  filteredData: PropTypes.arrayOf(PropTypes.shape),
  messageNoData: PropTypes.string,
  selectRows: PropTypes.bool,
  expandedRow: PropTypes.bool,
};

Table.defaultProps = {
  filterEnabled: false,
  className: "",
  columnsTable: [],
  handleFilter: () => {},
  filteredData: [],
  messageNoData: "",
  selectRows: true,
  expandedRow: true,
};

export default Table;
